import { BlobServiceClient } from '@azure/storage-blob';
// import {
//   AZURE_STORAGE_BLOB_TOKEN,
//   AZURE_STORAGE_BLOB_SAS_URL,
// } from 'constants';

export const uploadImage = async (file, azureStorageBlobSASUrl, azureStorageBlobToken) => {
  const blobServiceClient = new BlobServiceClient(
    azureStorageBlobSASUrl,
    azureStorageBlobToken
  );
  const containerClient = blobServiceClient.getContainerClient('');
  const blobClient = containerClient.getBlobClient(file.name);
  const blockBlobClient = blobClient.getBlockBlobClient();
  await blockBlobClient.uploadBrowserData(file, {
    blockSize   : 4 * 1024 * 1024,
    concurrency : 20,
    onProgress  : (ev) => console.log(ev),
  });
};
